module.exports = __webpack_public_path__ + "static/media/prize-mobile.388ab131.png";